
<!--课后服务-->
<template>
  <div style="border: 1px solid red;">
    <el-form label-position="center" label-width="140px" >
      <el-form-item label="课程名:" >
        <el-input readonly="true" style="width: 300px" v-model="detail.lessonName" placeholder="输入课程名"></el-input>
      </el-form-item>
      <el-form-item  label="会员姓名:">
        <el-input  readonly="true" style="width: 300px"  v-model="detail.childName" placeholder="输入姓名"></el-input>
      </el-form-item>
      <!--<el-form-item  label="上传照片">-->
        <!--<upload-img ref="uploadImg" style="width: 300px"></upload-img>-->
      <!--</el-form-item>-->
      <div v-if="detail.lessonTemplateId == 2">
        <!--基础游-->
        <el-form label-position="center" ref="baseRef"  :model="serverParam" :rules="rules" label-width="140px">
          <el-form-item  label="身高Cm:" prop="height" >
            <el-input  style="width: 300px" v-model="serverParam.height"></el-input>
          </el-form-item>
          <el-form-item  label="体重Kg:" prop="weight" >
            <el-input  style="width: 300px" v-model="serverParam.weight"></el-input>
          </el-form-item>
          <el-form-item  label="游泳时长(分钟):" prop="temperature" >
            <el-input  style="width: 300px" v-model="serverParam.swTime"></el-input>
          </el-form-item>
          <el-form-item  label="泳圈:"  prop="swCircle">
            <el-select style="width: 200px"  v-model="serverParam.swCircle" placeholder="请选择">
              <el-option
                v-for="item in storeSwCircleList"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item  label="互动内容:"  prop="temperature" >
            <el-checkbox-group style="width: 300px;" v-model="SW_INTERACTIVE_CONTENT.val">
              <el-checkbox v-for="item in SW_INTERACTIVE_CONTENT.options" :label="item" :key="item">{{item}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item  label="获得金币:">
            &nbsp;&nbsp;&nbsp;<el-input-number v-model="serverParam.gold" :precision="0"
                                               :step="10" :min="0" ></el-input-number>
          </el-form-item>
        </el-form>
        <div style=" display: flex;flex-direction: row; justify-content: center; width:100% ;" >
          <el-button type="primary" @click="handleSure('baseRef')">确认</el-button>
        </div>
      </div>
      <div v-if="detail.lessonTemplateId == 1">
        <!--亲子游-->
        <el-form label-position="center" ref="pcRef"  :model="serverParam" :rules="rules" label-width="140px">
          <el-form-item  label="游泳状态:" >
            <el-select style="width: 300px" v-model="SW_STATU.val" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in SW_STATU.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="踢腿:" >
            <el-select style="width: 300px" v-model="SW_KIKING.val" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in SW_KIKING.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="换气/闭气:" >
            <el-select style="width: 300px" v-model="SW_BREATE.val" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in SW_BREATE.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="手部动作:" >
            <el-select style="width: 300px" v-model="SW_HANDMOVE.val" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in SW_HANDMOVE.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="自救课:" >
            <el-select style="width: 300px" v-model="SW_HELPSELF.val" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in SW_HELPSELF.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="速度:" >
            <el-select style="width: 300px" v-model="SW_SPEED.val" placeholder="请选择" @change="onChaneWork">
              <el-option
                v-for="item in SW_SPEED.options"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="获得金币:">
            &nbsp;&nbsp;&nbsp;<el-input-number v-model="serverParam.gold" :precision="0"
                                                  :step="10" :min="0" ></el-input-number>
          </el-form-item>
        </el-form>
        <div style=" display: flex;flex-direction: row; justify-content: center; width:100% ;" >
          <el-button type="primary" @click="handleSure('pcRef')">确认</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<style>
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import messageUtils from "../../../utils/messageUtils";
  import commonUtils from "../../../utils/commonUtils";
  import {afterClassService} from "../../../api/StoreLesson";
  import UploadImg from "../../components/UploadImg";
  import enumsUtil, {EClassServiceItemType} from "../../../utils/enumsUtil";

  export default {
    name: 'AfterClassService',
    components: {UploadImg},
    props: {
      detail :{
        type : Object,
        default: () => ({lessonName: '1', childName: '2'})
        // required:true,
      },
      serviceItems:Array,
    },
    data() {
      return {
        rules:{
          // height:[{required:true,message:"请输入身高",trigger:"blur"}],
          weight:[{required:true,message:"请输入体重",trigger:"blur"}],
          // temperature:[{required:true,message:"请输入体温",trigger:"blur"}],
          swCircle:[{required:true,message:"请选择泳圈",trigger:"blur"}],
        },
        serverParam:{
          height:"",
          weight:"",
          temperature:"",
          swTime:"",
          swCircle:"",
          picList:[],
          classEvaluation:"", //评价
          gold:0,
        },

        SW_STATU:{val:"", options:[],},
        SW_KIKING:{val:"", options:[],},
        SW_BREATE:{val:"", options:[],},
        SW_HANDMOVE:{val:"", options:[],},
        SW_HELPSELF:{val:"", options:[],},
        SW_SPEED:{val:"", options:[],},
        SW_INTERACTIVE_CONTENT:{val:[], options:[],},
        storeSwCircleList:[],
      }
    },
    created(){

      this.initData();
    },
    methods: {
      initData(){

        globaldata.getStoreSwimCircle(this.getStoreSwimCircle);
        this.refreshService(this.serviceItems);
      },
      handleSure(ref){

        this.$refs[ref].validate((valid) => {
          if (valid) {
            let classEvaluation = "";
            if(this.detail.lessonTemplateId == enumsUtil.lessonTemplateIdCF()){
              classEvaluation = {
                SW_STATU:this.SW_STATU.val,
                SW_KIKING:this.SW_KIKING.val,
                SW_BREATE:this.SW_BREATE.val,
                SW_HANDMOVE:this.SW_HANDMOVE.val,
                SW_HELPSELF:this.SW_HELPSELF.val,
                SW_SPEED:this.SW_SPEED.val,
              }
              classEvaluation = JSON.stringify(classEvaluation);
            }
            else if (this.detail.lessonTemplateId == enumsUtil.lessonTemplateIdBS()) {
              let sc = "";
              if (commonUtils.isStringNull(this.SW_INTERACTIVE_CONTENT.val) == false){
                sc = {
                  SW_INTERACTIVE_CONTENT:this.SW_INTERACTIVE_CONTENT.val,
                }
                classEvaluation = JSON.stringify(sc);
              }

            }

            // let pic = this.$refs['uploadImg'].onGetPicUrls();
            // pic = JSON.stringify(pic);

            let param = {
              id:this.detail.id,
              height:this.serverParam.height,
              weight:this.serverParam.weight,
              swTime:this.serverParam.swTime,
              temperature:this.serverParam.temperature,
              circle:this.serverParam.swCircle,
              // picList:pic,
              classEvaluation:classEvaluation,
              gold:this.serverParam.gold,
            }


            this.$emit('onBtnOK',param);
          } else {
            return false
          }
        });

      },
      getStoreSwimCircle(list){

        this.storeSwCircleList = list;
      },

      refreshService(list){



        let enumTypes = EClassServiceItemType();
        for (let i =0;i< list.length;++i){
          let item = list[i];
          if (item.type == enumTypes.SW_STATU.v){
            this.SW_STATU.options = item.options;
          }else if (item.type == enumTypes.SW_KIKING.v) {
            this.SW_KIKING.options = item.options;
          }else if (item.type == enumTypes.SW_BREATE.v) {
            this.SW_BREATE.options = item.options;
          }else if (item.type == enumTypes.SW_HANDMOVE.v) {
            this.SW_HANDMOVE.options = item.options;
          }else if (item.type == enumTypes.SW_HELPSELF.v) {
            this.SW_HELPSELF.options = item.options;
          }else if (item.type == enumTypes.SW_SPEED.v) {
            this.SW_SPEED.options = item.options;
          }else if (item.type == enumTypes.SW_INTERACTIVE_CONTENT.v) {
            this.SW_INTERACTIVE_CONTENT.options = item.options;
          }
        }


      }


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/component/AfterClassService.vue